import { useState, useEffect } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { Switch } from 'components/common'
import { UserSettingsServices } from 'services'
import { toast } from 'components/common/Toast'
import { LeftArrow } from 'assets/icons/components/index'
import { setMainContent } from 'actions'
import { connect } from 'react-redux'

const Notifications = (props) => {
  const { dispatch } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingFetch, setIsLoadingFetch] = useState(false)
  const [inputValues, setInputValues] = useState({
    activity_related_profile: false,
    latest_news_our_service: false,
    message_from_out_partner: false
  })

  useEffect(() => {
    fetchSettings()
  }, [])

  const fetchSettings = async () => {
    setIsLoadingFetch(true)
    let { data, error } = await UserSettingsServices.GET_NOTIFICATION_SETTINGS()
    console.log(data)
    if (data) {
      let { activity_related_profile, latest_news_our_service, message_from_out_partner } = data
      setInputValues({
        activity_related_profile: activity_related_profile || false,
        latest_news_our_service: latest_news_our_service || false,
        message_from_out_partner: message_from_out_partner || false
      })
    }
    if (error) {
      console.log(error?.message)
    }
    setIsLoadingFetch(false)
  }

  const handleOnChange = event => {
    const value = event.target.checked
    const id = event.target.id
    setInputValues({ ...inputValues, [id]: value })
  }

  const handleSubmit = async () => {
    try {
      setIsLoading(true)
      let payload = inputValues

      let { data, error } = await UserSettingsServices.UPDATE_NOTIFICATION_SETTINGS(payload)
      if (data) {
        toast.success('Update notification settings successfully')
      }
      if (error) {
        throw error?.message
      }
    } catch (error) {
      toast.error(error)
    }
    setIsLoading(false)
  }

  let settings = [
    {
      name: 'activity_related_profile',
      label: 'Activities related to your profile',
      value: inputValues.activity_related_profile
    },
    {
      name: 'latest_news_our_service',
      label: 'Latest news about our services',
      value: inputValues.latest_news_our_service
    },
    {
      name: 'message_from_out_partner',
      label: 'Messages from our partners',
      value: inputValues.message_from_out_partner
    },
  ]

  const back = () => {
    dispatch(setMainContent('dashboard'))
  }

  return (
    <div className='main-content__notifications'>
      <div className='notifications__header'>
        <div className='header__heading'>Notifications</div>
        <div className='header__icon' onClick={() => back()}>
          <LeftArrow className='icon__icon' />
        </div>
      </div>
      <div className='notifications__container'>
        {settings.map(setting => (
          <div className='container__option' key={setting.name}>
            <div className='option__label'>
              {setting.label}
            </div>
            <Switch value={setting.value} id={setting.name} handleOnChange={handleOnChange} />
          </div>
        ))}
        <Button
          variant='primary'
          size='lg'
          className='form__button'
          style={{ magrinTop: '1rem' }}
          onClick={() => handleSubmit()}>
          {isLoading ? <Spinner
            as='span' animation='border' size='md' role='status'
          /> : 'Save'}
        </Button>
        {isLoadingFetch && <div className='main-content__setting-loading-overlay'>
          <Spinner
            as='span' animation='border' size='md' role='status' variant='secondary'
          />
        </div>}
      </div>
    </div >
  )
}
export default connect(null)(Notifications)